/**
 *
 * @param {*} imgSrc
 * @param {*} options
 * @returns
 *  {
 *    file: blob,
 *    imgURL: e.target.result
 *  }
 */
export default function (
  imgSrc,
  {
    targetSize = 1048576 * 2,
    type = 'image/png',
    aspectRatio = null,
    shrinkRatio = 0.95,
    minWidth = null,
    minHeight = null,
    maxWidth = null,
    maxHeight = null
  }
) {
  return new Promise((resolve, reject) => {
    if (!imgSrc) {
      reject(new Error('imgSrc is empty'));
    }
    if (shrinkRatio > 1) {
      reject(new Error('shrinkRatio must be less than 1'));
    }

    const canvas = document.createElement('canvas');

    const fr = new FileReader();
    const ctx = canvas.getContext('2d');
    const img = new Image();
    let tests = 0;

    img.onload = () => {
      const imgAspectRatio = aspectRatio || img.width / img.height;
      if (maxWidth !== null && img.width > maxWidth && imgAspectRatio >= 1) {
        img.width = maxWidth;
        img.height = img.width / imgAspectRatio;
        tests++;
      }

      if (minWidth !== null && img.width < minWidth && imgAspectRatio >= 1) {
        img.width = minWidth;
        img.height = img.width / imgAspectRatio;
        tests++;
      }

      if (maxHeight !== null && img.height > maxHeight && imgAspectRatio < 1) {
        img.height = maxHeight;
        img.width = img.height * imgAspectRatio;
        tests++;
      }

      if (minHeight !== null && img.height < minHeight && imgAspectRatio < 1) {
        img.height = minHeight;
        img.width = img.height * imgAspectRatio;
        tests++;
      }

      canvas.width = img.width;
      canvas.height = img.height;

      ctx.drawImage(img, 0, 0, img.width, img.height);

      let file = null;

      const doConvert = () => {
        canvas.toBlob((blob) => {
          file = blob;
          if (file.size > targetSize) {
            img.width = img.width * shrinkRatio;
            img.height = img.width / imgAspectRatio;
            canvas.width = img.width;
            canvas.height = img.height;

            ctx.drawImage(img, 0, 0, img.width, img.height);
            tests++;
            doConvert();
          } else {
            fr.onload = (e) => {
              resolve({
                tests,
                file: blob,
                imgURL: e.target.result
              });
            };
            fr.readAsDataURL(file);
          }
        }, type);
      };

      doConvert();
    };

    img.src = imgSrc;
  });
}
